@if (label) {
  <label
    attr.for="{{id}}"
    soho-label
    [required]="required$ | async"
    lm-label
    [layoutField] = "field"
    [personalize]="personalize"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
  >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}</label>
}
<lm-lpl-editor-compare #LplEditorCompare
  soho-alert
  soho-trackdirty
  [uniqueId]="id"
  [original]="compareLpl"
  [lpl]="editorLpl"
  [validationOptions]="editorValidationOptions"
  [readonly]="(readOnly$ | async) || displayAsText"
  (lplChangedEvent)="onLplChangedEvent($event)"
  (blur)="onBlur($event)"
  (change)="onChange()"
  (input)="onInput($event)"
></lm-lpl-editor-compare>
